import { React } from 'Imports';
import { useState } from 'react';
import { isEncompass } from '$Utilities/integrationPlatform';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';

const styles = require('$Components/Shared/Button/VPButton.scss') as {
    button: string;
    geotab: string;
    encompass: string;
    filled: string;
    outlined: string;
    text: string;
};

type VPButtonVariant = 'filled' | 'outlined' | 'text';

interface IVPButtonColorOverrides {
    color?: string;
    backgroundColor?: string;
    borderColor?: string;
}

interface IVPButtonProps {
    variant?: VPButtonVariant;
    text?: string;
    disabled?: boolean;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    isLoading?: boolean;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    width?: number;
    padding?: string;
    colorOverrides?: IVPButtonColorOverrides;
    hoverColorOverrides?: IVPButtonColorOverrides;
}

const VPButton = (props: IVPButtonProps) => {
    const {
        variant = 'filled',
        text,
        disabled = false,
        startIcon,
        endIcon,
        isLoading,
        onClick,
        width,
        padding,
        colorOverrides,
        hoverColorOverrides,
    } = props;

    const [isHovered, setIsHovered] = useState(false);

    const className = [styles.button, isEncompass ? styles.encompass : styles.geotab, styles[variant]].join(' ');

    const activeOverrides = isHovered && !disabled ? hoverColorOverrides : colorOverrides;

    const resolvedBackgroundColor = activeOverrides?.backgroundColor ?? (hoverColorOverrides?.backgroundColor !== undefined ? (colorOverrides?.backgroundColor ?? 'transparent') : undefined);

    const inlineStyles: React.CSSProperties = {
        ...(activeOverrides?.color && { color: activeOverrides.color }),
        ...(resolvedBackgroundColor !== undefined && { backgroundColor: resolvedBackgroundColor }),
        ...(activeOverrides?.borderColor && { borderColor: activeOverrides.borderColor }),
        ...(width && { width: `${width}px` }),
        ...(padding && { padding }),
    };

    return (
        <button
            className={className}
            style={inlineStyles}
            onClick={onClick}
            disabled={disabled}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {startIcon}
            {isLoading ? <CircularProgress size={16} color="inherit" /> : text}
            {endIcon}
        </button>
    );
};

export default VPButton;
